import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'
import MedshrTeam from '../components/Team/container/MedshrTeam'
import Team from '../components/Team/container/TeamPage'

const TeamPage = () => {
  const teamName = 'medshr'
  return (
    <Team teamName={teamName}>
      <MedshrTeam teamName={teamName} />
    </Team>
  )
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'teampage'])),
    },
  }
}

export default TeamPage
